import { Pipe, PipeTransform } from '@angular/core';
import { LinkConfigEntry } from '../../../core/base-api';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateLinkName',
  pure: false
})
export class TranslateLinkNamePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: LinkConfigEntry, type: 'LINK' | 'TEXT' = 'TEXT'): string {
    if (type === 'LINK') {
      return this.getLink(value);
    }
    return this.getText(value);
  }

  getText(value: LinkConfigEntry): string {
    switch (this.translateService.currentLang) {
      case 'de':
        return value.linkTextDe;
      case 'fr':
        return value.linkTextFr;
      default:
        return value.linkTextDe;
    }
  }

  getLink(value: LinkConfigEntry): string {
    switch (this.translateService.currentLang) {
      case 'de':
        return value.linkDe;
      case 'fr':
        return value.linkFr;
      default:
        return value.linkDe;
    }
  }
}
